/* Common Imports */

import { styled, useTheme } from "@mui/system";
import React from "react";

/* Redux & Type Imports */

import { NextRouter } from "next/router";
import StateInterface from "../../../../redux-magic/state-interface";

/* Component Imports */

import { Autocomplete, Tab, TextField, Typography } from "@mui/material";
import debounce from "lodash/debounce";

/* Icon Imports */

/* Styled Components */

const RootDiv = styled("div")(({ theme }) => ({
	background: theme.palette.background.paper,
	borderRadius: "0rem",
	height: "100%",
	width: "100%",
	padding: "0rem 0rem 0rem 0rem",
	[theme.breakpoints.up("md1190")]: {
		padding: "0rem 0rem 0rem 0rem",
	},
}));

const CustomTab = styled(Tab)(({ theme }) => ({
	padding: "0rem 1rem 0rem 1rem",
	textTransform: "none",
	borderRadius: "2rem",
	minHeight: "2.5rem",
	maxHeight: "2.5rem",
	background: "#eeeeee",
	color: "#6d6d6d",
}));

const TabIconTitleRow = styled("div")(({ theme }) => ({
	width: "100%",
	display: "flex",
	flexDirection: "row",
	justifyContent: "center",
	alignItems: "center",
	gap: "0.5rem",
}));

const TabTitle = styled(Typography)(({ theme }) => ({
	fontSize: "0.875rem",
}));

//  Interfaces

// interface OptionInterface {
// 	is_business_profile: boolean;
// 	_id: ObjectId;
// 	name: string;
// 	slug: string;
// 	dp_url: string;
// }

const SearchDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "center",
	alignItems: "center",
	width: "100%",
	padding: "0.5rem 1.25rem 0.5rem 1.25rem",
}));

const CustomAutocomplete = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "center",
	alignItems: "center",
	width: "100%",
}));

const ChatListScreen = ({
	session,
	dispatch,
	router,
	searchInputValue,
	setSearchInputValue,
	clearAutoComplete,
	setClearAutoComplete,
}: {
	session: StateInterface["redux_session"];
	dispatch: Function;
	router: NextRouter;
	searchInputValue: string | undefined;
	setSearchInputValue: React.Dispatch<React.SetStateAction<string | undefined>>;
	clearAutoComplete: boolean;
	setClearAutoComplete: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
	const theme = useTheme();

	/* Translations */

	const localLang = {
		chats: router.locale === "ar-AE" ? "الدردشات" : router.locale === "kn-IN" ? "ಚಾಟ್‌ಗಳು" : "Chats",
		requests: router.locale === "ar-AE" ? "طلبات" : router.locale === "kn-IN" ? "ವಿನಂತಿಗಳು" : "Requests",
	};

	const [inputValue, setInputValue] = React.useState("");

	// Create a memoized debounced function
	const debouncedSearch = React.useMemo(
		() =>
			debounce((searchValue: string) => {
				if (searchValue.length > 0) {
					setSearchInputValue(searchValue);

					setClearAutoComplete(false);
				} else {
					setSearchInputValue("");

					setClearAutoComplete(true);
				}
			}, 300), // 300ms delay
		[setSearchInputValue, setClearAutoComplete],
	);

	// Cleanup on unmount
	React.useEffect(() => {
		return () => {
			debouncedSearch.cancel();
		};
	}, [debouncedSearch]);

	return (
		<React.Fragment>
			<RootDiv>
				{/* Search Chats */}

				<SearchDiv>
					<Autocomplete
						freeSolo
						options={[]}
						value={searchInputValue ? searchInputValue : ""}
						inputValue={inputValue}
						onInputChange={(event, newInputValue) => {
							setInputValue(newInputValue);
							debouncedSearch(newInputValue);
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								sx={{ width: "100%" }}
								variant="outlined"
								size="small"
								placeholder="Search chats..."
							/>
						)}
						sx={{
							width: "100%",
							minWidth: "10rem",
						}}
					/>
				</SearchDiv>
			</RootDiv>
		</React.Fragment>
	);
};

export default ChatListScreen;
